var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('m-form', _vm._g({ ref: "form", attrs: { "formConfig": _vm.formConfig, "formValue": _vm.formValue, "formItemList": _vm.innerFormItemList, "layout": _vm.layout, "customFormItem": _vm.customFormItem } }, _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };